module.exports = __webpack_public_path__ + "img/anm22logo-extended.2eb829b5.png";